import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Inbox, ChevronRight } from 'lucide-react';
import { goAdmin } from '../../lib/adminLinks';
import { HelpLink } from './HelpLink';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Separate per-type counts of quote-intent requests still waiting for a Sales Quote / link.
export const UnlinkedRequestsCounts = ({ token, testId = 'unlinked-requests' }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    axios.get(`${API_URL}/admin/requests/unlinked-counts`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [token]);
  if (!items?.length) return null;
  return (
    <div className="rounded-xl border border-neutral-200 bg-white px-4 py-3" data-testid={testId}>
      <p className="text-xs font-medium uppercase tracking-wider text-neutral-500 mb-2 flex items-center gap-1.5"><Inbox className="w-3.5 h-3.5" />Waiting for a Sales Quote <HelpLink topic="waiting-for-quote" /></p>
      <div className="grid gap-2 sm:grid-cols-3">
        {items.map((it) => (
          <button key={it.key} type="button" onClick={() => goAdmin(it.tab, { filter: 'unlinked' })}
            className="group flex items-center justify-between gap-3 rounded-lg border border-neutral-200 px-3 py-2 text-left hover:border-amber-400 hover:bg-amber-50/50 transition-colors" data-testid={`${testId}-${it.key}`}>
            <span className="text-sm text-neutral-700">{it.label}</span>
            <span className="flex items-center gap-1">
              <span className={`text-lg font-semibold ${it.count ? 'text-amber-700' : 'text-neutral-400'}`} data-testid={`${testId}-${it.key}-count`}>{it.count}</span>
              <ChevronRight className="w-4 h-4 text-neutral-400 group-hover:translate-x-0.5 transition-transform" />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
